import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DefectPerformanceChartMasterDataView } from "src/components/views/spc/masterData/performanceDefectCharts/DefectPerformanceChartMasterDataView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/masterData/yieldCharts")({
	staticData: { title: i18n.t("yield_charts"), legacyViewKey: "defectPerformanceChartMasterDataView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DefectPerformanceChartMasterDataView />;
}
